import React from 'react'
import { mutualTheme } from '~/utils/theme'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { DocumentationOnboardHeader, DocumentationOnboardHeaderProps } from './components'

export type DocumentationOnboardContainerProps = DocumentationOnboardHeaderProps

const useStyles = makeStyles({
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: mutualTheme.spacing(5),
    [mutualTheme.breakpoints.down('md')]: {
      padding: mutualTheme.spacing(3)
    }
  },
  childrenContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  }
})

export const DocumentationOnboardContainer: React.FC<DocumentationOnboardContainerProps> = (props) => {
  const { title, description, children, actions, customHeader } = props
  const classes = useStyles()

  return (
    <Box className={classes.container}>
      <DocumentationOnboardHeader customHeader={customHeader} title={title} description={description} actions={actions} />
      <Box className={classes.childrenContainer}>
        {children}
      </Box>
    </Box>
  )
}
